import { arrayRequired, labeled } from '../../util/joi';
import { schema as contactPersonEmploymentSchema } from './ContactPersonEmployment.schema';
import { schema as contactPersonDetailsSchema } from './ContactPersonDetails.schema';
import { schema as contactPersonInformationSchema } from './ContactPersonInformation.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    information: contactPersonInformationSchema(Joi, label),
    contact: contactPersonDetailsSchema(Joi, label),
    employments: arrayRequired(
      Joi,
      contactPersonEmploymentSchema(Joi, labeled(label, 'Employment -'))
    )
      .min(1)
      .label(labeled(label, 'Employment - At least one employment is required'))
  });

export default {
  schema
};
